import React, { useState, useEffect } from "react";
import CustomTextField from "../../../components/Textfield";
import Button from "../../../components/Button";
import { useDispatch, useSelector } from "react-redux";
import { getVerifyEmailOtp, updateProfile, viewProfile } from "../../../http/auth";
import { showToast } from "../../../store/slices/common";
import Spinner from "../../../components/Spinner";
import { Box, Typography } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import VerifyEmail from "./VerifyEmail";
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const EditProfile = ({ smScreen }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [profileDetails, setProfileDetails] = useState({})
  const [resendTimer, setResendTimer] = React.useState(0);
  const [showResend, setShowResend] = React.useState(false)
  const [showVerifyButton, setShowVerifyButton] = useState(false);
  const [showVerifiedButton, setShowVerifiedButton] = useState(false)
  const [openVerifyModal, setOpenVerifyModal] = useState(false)
  const [verifyEmail, setVerifyEmail] = useState("")

  useEffect(() => {
    getProfileHandler()
  }, [])

  const initialValues = {
    firstName: profileDetails.firstName || "",
    lastName: profileDetails.lastName || "",
    email: profileDetails.email || "",
    // phone: profileDetails.phoneNo ||"+1 (416) "
    phoneNo: profileDetails.phoneNo || "+1"
  };

  const emailRegex = /^[A-Za-z0-9._]+@[a-z]+\.[a-z]{2,3}$/;
  const phoneNumberRegex = /^(?:\+1\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
  const validationSchema = Yup.object({
    firstName: Yup.string().required("First name is required"),
    lastName: Yup.string().required("Last name is required"),
    email: Yup.string().required("Email is required").matches(emailRegex, "Invalid email"),
    phoneNo: Yup.string().required("Phone number is required").matches(phoneNumberRegex, "Invalid phone number")
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => { saveHandler(values) }
  });

  const handleVerifyEmail = async () => {
    try {
      setLoading(true)
      const res = await getVerifyEmailOtp({ email: formik.values.email })
      if (res.status == 200) {
        setVerifyEmail(formik.values.email)
        setOpenVerifyModal(true)
      }
      setLoading(false)
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  };

  const verifiedHandler = () => {
    setShowVerifyButton(false)
    setShowVerifiedButton(true)
  }

  const handleChange = (e) => {
    if (e.target.value?.length < 50) {
      if (e.target.name === "phoneNo") {
        if (e.target.value?.length > 1 && e.target.value?.length < 13)
          formik.setFieldValue(e.target.name, e.target.value);
      } else
        formik.setFieldValue(e.target.name, e.target.value);
    }
    setShowResend(false)
  };


  const getProfileHandler = async () => {
    try {
      setLoading(true)
      const res = await viewProfile()
      setProfileDetails(res.data.data)
      setLoading(false)
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }
  useEffect(() => {
    // Check if the email is valid and different from the current profile email
    const emailChanged = formik.values.email !== profileDetails.email;
    const isValidEmail = emailRegex.test(formik.values.email);
    setShowVerifyButton(emailChanged && isValidEmail);
  }, [formik.values.email, profileDetails.email]);

  const saveHandler = async (values) => {
    try {
      setLoading(true)
      const res = await updateProfile(values)
      setLoading(false)
      if (res.status === 200) {
        dispatch(showToast({ color: "success", msg: res.data.message }));
        getProfileHandler()
        setShowVerifiedButton(false)
      }
    } catch (err) {
      console.log(err)
      dispatch(showToast({ color: "error", msg: err?.response?.data?.message }));
    }
  }

  const getDisabled = () => {
    return !formik.values.firstName ||
      !formik.values.lastName ||
      !formik.values.email ||
      !formik.values.phoneNo ||
      showVerifyButton ||
      !formik.values ||
      (profileDetails.firstName === formik.values.firstName && profileDetails.lastName === formik.values.lastName
        && profileDetails.email === formik.values.email && profileDetails.phoneNo === formik.values.phoneNo)
  }


  return (
    <>
      {loading && <Spinner />}
      {verifyEmail && <VerifyEmail open={openVerifyModal} setOpen={setOpenVerifyModal} email={verifyEmail} verifiedHandler={verifiedHandler} />}
      <Box
        display="flex"
        maxWidth="380px"
        flexDirection="column"
        padding={{ xs: "0", md: "0 20px" }}
      >
        <form onSubmit={formik.handleSubmit}>
          <Typography
            className="header"
            color="#687F89"
            width="100%"
            fontWeight="400"
            fontSize="16px"
          >
            First Name
          </Typography>
          <Box
            borderRadius="40px"
            display="flex"
            marginTop="15px"
            width="100%"
            flexDirection="column"
            justifyContent="center"
          >
            <CustomTextField
              type="text"
              name="firstName"
              placeholder="First Name"
              value={formik.values.firstName}
              onChange={handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.firstName &&
                Boolean(formik.errors.firstName)
              }
              errorMessage={
                formik.touched.firstName && formik.errors.firstName
              }
            />
          </Box>
          <Typography
            className="header"
            color="#687F89"
            marginTop="24px"
            width="100%"
            fontWeight="400"
            fontSize="16px"
          >
            Last Name
          </Typography>
          <Box
            borderRadius="40px"
            display="flex"
            marginTop="15px"
            width="100%"
            flexDirection="column"
            justifyContent="center"
          >
            <CustomTextField
              type="text"
              name="lastName"
              placeholder="Last Name"
              value={formik.values.lastName}
              onChange={handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.lastName && Boolean(formik.errors.lastName)
              }
              errorMessage={
                formik.touched.lastName && formik.errors.lastName
              }
            />
          </Box>
          <Typography
            className="header"
            color="#687F89"
            marginTop="24px"
            width="100%"
            fontWeight="400"
            fontSize="16px"
          >
            Email Address
          </Typography>
          <Box
            borderRadius="40px"
            display="flex"
            marginTop="15px"
            width="100%"
            flexDirection="column"
            position="relative"
            justifyContent="center"
          >
            <CustomTextField
              type="email"
              name="email"
              placeholder="Email Address"
              value={formik.values.email}
              onChange={handleChange}
              onBlur={formik.handleBlur}
              isVerifyEmail={true}
              error={
                formik.touched.email &&
                Boolean(formik.errors.email)
              }
              errorMessage={
                formik.touched.email && formik.errors.email
              }
            />
            {showVerifyButton && (
              <Box
                onClick={handleVerifyEmail}
                fullWidth
                variant="text"
                // disabled={resendTimer > 0}
                sx={{
                  cursor: "pointer",
                  position: "absolute",
                  left: 336,
                  color: resendTimer > 0 ? "#ccc" : "#0832DE",
                  "&:hover": { background: "transparent" },
                }}
              >
                Verify
              </Box>
            )}
            {showVerifiedButton && (
              <Box
                fullWidth
                variant="text"
                sx={{
                  position: "absolute",
                  left: 336,
                  background: "transparent"
                }}
              >
                <CheckCircleRoundedIcon sx={{ color: "green" }} />
              </Box>
            )}
          </Box>
          <Typography
            className="header"
            color="#687F89"
            marginTop="24px"
            width="100%"
            fontWeight="400"
            fontSize="16px"
          >
            Phone Number
          </Typography>
          <Box
            borderRadius="40px"
            display="flex"
            marginTop="15px"
            width="100%"
            flexDirection="column"
            justifyContent="center"
          >
            <CustomTextField
              type="phone"
              name="phoneNo"
              placeholder="Phone Number"
              value={formik.values.phoneNo}
              onChange={handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.phoneNo &&
                Boolean(formik.errors.phoneNo)
              }
              errorMessage={
                formik.touched.phoneNo && formik.errors.phoneNo
              }
            />
          </Box>
          {showResend && <Button
            onClick={handleResend}
            fullWidth
            variant="text"
            disabled={resendTimer > 0}
            sx={{
              mt: 1,
              color: resendTimer > 0 ? "#ccc" : "#0832DE",
              "&:hover": { background: "transparent" },
            }}
          >
            Resend Email {resendTimer > 0 && `(${resendTimer}s)`}
          </Button>}
          <Box
            borderRadius="40px"
            display="flex"
            marginTop="2rem"
            width="100%"
            flexDirection="column"
            justifyContent="center"
          >
            <Button
              style={{ marginTop: 0, width: "50%", minWidth: "150px" }}
              className="theme-btn-contained theme-btn theme-auth-btn"
              label="Save"
              variant="contained"
              color="primary"
              typeButton="submit"
              disabled={getDisabled()}


            />
          </Box>
        </form>
      </Box>
    </>
  );
};

export default EditProfile;
